import styled from '@emotion/styled';
import { sdsColor, sdsPrimitiveColor } from '@staging-design-system/tokens';
import { rem } from '@utils';

const RING_SIZE_PX = 60;

const Root = styled.article`
  align-items: center;
  background: ${sdsColor.background.defaultDefault};
  border: ${rem(1)} solid ${sdsColor.border.defaultDefault};
  border-radius: ${rem(8)};
  display: flex;
  flex: 1 1 ${rem(160)};
  flex-direction: column;
  gap: ${rem(16)};
  min-width: ${rem(160)};
  padding: ${rem(16)};
  width: 100%;
`;

const Ring = styled.div`
  height: ${RING_SIZE_PX}px;
  position: relative;
  width: ${RING_SIZE_PX}px;
`;

const RingSvg = styled.svg`
  display: block;
  flex-shrink: 0;
`;

const RingTrack = styled.circle`
  fill: none;
  stroke: ${sdsPrimitiveColor.grey['200']};
`;

const RingProgress = styled.circle`
  fill: none;
  stroke: ${sdsPrimitiveColor.pink['600']};
  stroke-linecap: round;
`;

const RingContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  inset: 0;
  justify-content: center;
  position: absolute;
  text-align: center;
`;

const Percentage = styled.p`
  color: ${sdsColor.text.defaultDefault};
  font-size: ${rem(14)};
  font-weight: 600;
  line-height: ${rem(16)};
  margin: 0;
`;

const Index = styled.p`
  color: ${sdsColor.text.defaultSecondary};
  font-size: ${rem(10)};
  font-weight: 500;
  line-height: ${rem(14)};
  margin: 0;
`;

const Label = styled.p`
  color: ${sdsColor.text.defaultDefault};
  font-size: ${rem(12)};
  font-weight: 400;
  line-height: ${rem(16)};
  margin: 0;
  text-align: center;
`;

export default {
  Root,
  Ring,
  RingSvg,
  RingTrack,
  RingProgress,
  RingContent,
  Percentage,
  Index,
  Label
};
